import { BUBBLETAP_TEL } from '@repo/constants';

import * as Styled from '../../policy.styled';

export default function PrivacyPolicyTh() {
  return (
    <Styled.MainWrapper>
      <h3>นโยบายการคุ้มครองข้อมูลส่วนบุคคลของบริษัท บับเบิ้ลแท็ป จำกัด</h3>
      <p>ข้อที่ 1 นโยบายการคุ้มครองข้อมูลส่วนบุคคล</p>
      <ol>
        ① การเก็บรวบรวมข้อมูลส่วนบุคคล
        <br />
        บริษัท บับเบิ้ลแท็ป จำกัด (ต่อไปนี้เรียกว่า “บริษัท”) ตระหนักถึงความสำคัญของข้อมูลส่วนบุคคลของผู้ใช้
        เพื่อให้สามารถเชื่อมั่น
        ได้ว่าบริษัทมีความโปร่งใสและความรับผิดชอบในการปกป้องข้อมูลส่วนบุคคลที่ผู้ใช้ให้ไว้ผ่านบริการต่าง ๆ ของบริษัท
        เช่น Tingle, Reward เป็นต้น (เรียกรวมว่า “บริการ”) เพื่อให้เป็นไปตามมาตรฐานด้านการคุ้มครองข้อมูลส่วนบุคคล
        บริษัทดำเนินการตามกฎหมายและระเบียบที่เกี่ยวข้อง ได้แก่ พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
        พระราชบัญญัติคุ้มครองความลับในการสื่อสาร พระราชบัญญัติธุรกิจการสื่อสารทางอิเล็กทรอนิกส์
        พระราชบัญญัติส่งเสริมการใช้เครือข่ายข้อมูลและการคุ้มครองข้อมูล
        <br />
        <br />
        บริษัทจะเก็บรวบรวมข้อมูลส่วนบุคคลในขอบเขตที่จำเป็นเท่านั้น เพื่อใช้ในการให้บริการอย่างเหมาะสม
        ผู้ใช้สามารถเข้าถึงบริการของบริษัทได้โดยไม่จำเป็นต้องเปิดเผยข้อมูลส่วนบุคคลทั้งหมด และหากสมัครสมาชิก
        จะสามารถเข้าถึงบริการที่หลากหลายยิ่งขึ้นได้ ในการเก็บรวบรวมข้อมูลส่วนบุคคล บริษัทจะดำเนินการโดยชอบด้วยกฎหมาย
        บริษัทจะทำการแจ้งให้ทราบล่วงหน้าและขอความยินยอมจากผู้ใช้ก่อนเสมอ ทั้งนี้
        บริษัทจะไม่เก็บรวบรวมข้อมูลที่มีความอ่อนไหวโดยไม่ได้รับความยินยอมจากผู้ใช้
        <br />
        <br /> - ข้อมูลจำเป็น: ข้อมูลที่จำเป็นต่อการให้บริการตามวัตถุประสงค์หลักของระบบ
        <br />- ข้อมูลทางเลือก:
        ข้อมูลเพิ่มเติมที่ใช้เพื่อมอบประสบการณ์การใช้งานที่เหมาะสมและตรงกับความต้องการของผู้ใช้มากยิ่งขึ้น
        <br />
        <br />
        <li>
          การให้บริการ Tingle และ Reward
          <ol>
            <li>ข้อมูลจำเป็น: Social ID, ไอดี</li>
            <li>ข้อมูลทางเลือก: อีเมล, รูปโปรไฟล์, ผู้ใช้ลงชื่อเข้าใช้โดยใช้บัญชีโซเชียลมีเดีย, ชื่อเล่น</li>
          </ol>
        </li>
        <li>
          การกู้คืนบัญชี
          <ol>
            <li>ข้อมูลจำเป็น: Social ID, ไอดี, อีเมล</li>
          </ol>
        </li>
        <li>
          การชำระเงิน และการใช้บริการที่มีค่าใช้จ่าย
          <ol>
            <li>
              ข้อมูลจำเป็น: วันและเวลาที่ชำระเงิน, วิธีการชำระเงิน, แพลตฟอร์มที่ใช้ชำระเงิน, จำนวนเงิน, สกุลเงิน, IP
              ที่ใช้ในการทำธุรกรรม, Google/Apple Pay ID
            </li>
          </ol>
        </li>
        <li>
          Tingle Reward Incentive Program
          <ol>
            <li>
              ข้อมูลจำเป็น: Social ID, ไอดี, ชื่อ-สกุล, หมายเลขบัตรประจำตัวประชาชน, ชื่อเจ้าของบัญชี, ธนาคาร,
              เลขที่บัญชี, กรณีมีรายได้เกิดขึ้น จำเป็นต้องยืนยันหมายเลขบัตรประชาชน
            </li>
          </ol>
        </li>
        <li>
          การใช้คอนเทนต์ (อ้างอิงข้อ 2 วรรค 2 ของเงื่อนไขการใช้บริการ)
          <ol>
            <li>ข้อมูลจำเป็น: คอนเทนต์ที่ใช้บริการ, วันเวลาในการใช้งาน, วันเวลาที่ซื้อ</li>
          </ol>
        </li>
        <li>
          ผู้ขายรายบุคคลใน Marketplace
          <ol>
            <li>
              ข้อมูลจำเป็น: Social ID, ไอดี, ชื่อ, อีเมล, หมายเลขโทรศัพท์มือถือ, กรณีเป็นผู้ขายที่ยังไม่บรรลุนิติภาวะ:
              ข้อมูลของผู้แทนโดยชอบธรรม (ชื่อ-สกุล, ความสัมพันธ์กับผู้ขาย, วันเดือนปีเกิด, ที่อยู่, หมายเลขโทรศัพท์,
              อีเมล, สำเนาบัตรประชาชน, สูติบัตรหรือหลักฐานความสัมพันธ์), กรณีมีรายได้เกิดขึ้น:
              หมายเลขบัตรประจำตัวประชาชน, ข้อมูลบัญชีธนาคาร (ชื่อเจ้าของบัญชี, ธนาคาร, เลขที่บัญชี)
            </li>
          </ol>
        </li>{' '}
        <li>
          ผู้ขายเป็นนิติบุคคล
          <ol>
            <li>
              ข้อมูลจำเป็น: Social ID, ไอดี, ชื่อ-สกุล, อีเมล, ชื่อผู้แทน/กรรมการผู้มีอำนาจ, หมายเลขโทรศัพท์,
              ที่อยู่สถานประกอบการ, ชื่อ/หมายเลขโทรศัพท์/อีเมลของผู้ประสานงาน, ข้อมูลบัญชีธนาคาร (ชื่อเจ้าของบัญชี,
              ธนาคาร, เลขที่บัญชี), เอกสารประกอบ (หนังสือรับรองการจดทะเบียนบริษัท, หนังสือรับรอง, สำเนาสมุดบัญชี,
              แบบแจ้งบัญชีรับเงิน, หนังสือมอบอำนาจ)
            </li>
          </ol>
        </li>
        <li>
          การส่งผลงานเข้าร่วมประกวด
          <ol>
            <li>
              ข้อมูลจำเป็น: ชื่อเล่น หรือ ไอดี, (กรณีผู้มีอายุตั้งแต่ 14 ปีขึ้นไป) หมายเลขโทรศัพท์,
              (กรณีส่งผลงานที่จำกัดอายุไม่ต่ำกว่า 15 ปี) ข้อมูลยืนยันตัวตน (ชื่อ-สกุล, วันเดือนปีเกิด, เพศ, อีเมล,
              หมายเลขบัญชีธนาคาร, สัญชาติ, หมายเลขโทรศัพท์มือถือ, ข้อมูลเครือข่ายมือถือ, ข้อมูลยืนยันตัวตนแบบเข้ารหัส
              (CI))
            </li>
          </ol>
        </li>
        <li>
          การยืนยันตัวตน
          <ol>
            <li>
              ข้อมูลจำเป็น: ชื่อ-สกุล, วันเดือนปีเกิด, เพศ, สัญชาติ, หมายเลขโทรศัพท์มือถือ,ข้อมูลเครือข่ายมือถือ,
              ข้อมูลยืนยันตัวตนแบบเข้ารหัส, ข้อมูลตรวจสอบการสมัครซ้ำ (DI)
            </li>
          </ol>
        </li>
        <li>
          การเข้าร่วมกิจกรรมและการรับของรางวัล
          <ol>
            <li>ข้อมูลจำเป็น: ชื่อ-สกุล, ที่อยู่, หมายเลขโทรศัพท์มือถือ, อีเมล, หมายเลขบัตรประจำตัวประชาชน</li>
          </ol>
        </li>
        <li>
          การติดต่อฝ่ายบริการลูกค้า
          <ol>
            <li>ข้อมูลจำเป็น: หมายเลขโทรศัพท์มือถือ, Social ID, ไอดี, อีเมล</li>
          </ol>
        </li>
      </ol>
      <ol>
        ② ข้อมูลที่ถูกเก็บรวบรวมโดยอัตโนมัติขณะใช้บริการ
        <br />
        เมื่อผู้ใช้ใช้งานบริการ บริษัทอาจเก็บข้อมูลบางประการโดยอัตโนมัติ เช่น ข้อมูลอุปกรณ์: ชื่อรุ่น, รหัสอุปกรณ์, MAC
        Address, ระบบปฏิบัติการ (OS), ที่อยู่ IP, คุกกี้, บันทึกการเข้าใช้งาน (Access Logs), ประวัติการใช้งานบริการ,
        ประวัติการใช้งานที่ไม่เหมาะสม
        <br />
        <br />
        ③ วิธีการเก็บรวบรวมข้อมูลส่วนบุคคล
        <br />
        บริษัทจะดำเนินการเก็บรวบรวมข้อมูลส่วนบุคคลโดยชอบด้วยกฎหมาย ภายใต้หลักการที่โปร่งใส โดยจะแจ้งให้ผู้ใช้ทราบ
        และขอความยินยอมล่วงหน้า โดยวิธีการดังต่อไปนี้
        <ol>
          <li>
            กรณีที่ผู้ใช้ให้ความยินยอมต่อการเก็บรวบรวมข้อมูลส่วนบุคคล ในระหว่างขั้นตอนการสมัครสมาชิก
            หรือการใช้บริการของบริษัท
          </li>
          <li>
            การเก็บรวบรวมข้อมูลผ่านผู้ให้บริการบัญชีโซเชียลมีเดีย ที่บริษัทใช้ในการให้บริการ
            โดยได้รับข้อมูลจากแพลตฟอร์มโซเชียลมีเดียตามที่ผู้ใช้เชื่อมต่อไว้
          </li>
          <li>การเก็บรวบรวมข้อมูลที่ได้รับจากบริการของพันธมิตร หรือหน่วยงานที่ร่วมให้บริการ</li>
          <li>การให้ข้อมูลโดยตรงผ่านการติดต่อกับฝ่ายบริการลูกค้า เช่น เว็บไซต์ อีเมล โทรศัพท์ หรือโทรสาร</li>
          <li>การเก็บรวบรวมข้อมูลจากการเข้าร่วมกิจกรรม หรืออีเวนต์ที่จัดขึ้นทั้งในรูปแบบออนไลน์ และออฟไลน์</li>
        </ol>
      </ol>
      <p>ข้อที่ 2 การใช้ข้อมูลส่วนบุคคล</p>
      บริษัทจะใช้ข้อมูลส่วนบุคคลของผู้ใช้เพื่อวัตถุประสงค์ที่ระบุไว้เท่านั้น หากมีการเปลี่ยนแปลงวัตถุประสงค์
      บริษัทจะดำเนินการแจ้งให้ผู้ใช้ทราบล่วงหน้าและขอความยินยอมก่อนทุกครั้ง
      โดยข้อมูลส่วนบุคคลจะถูกใช้เพื่อวัตถุประสงค์ดังต่อไปนี้
      <br />
      <br />
      ① การยืนยันตัวตนของสมาชิก/ การตรวจสอบความประสงค์ในการสมัครสมาชิก, การป้องกันการใช้งานโดยมิชอบ,
      การยืนยันและพิสูจน์ตัวตน, การจัดการข้อร้องเรียน, การระงับข้อพิพาท
      <br />
      ② การให้บริการฟังก์ชันแจ้งเตือนกิจกรรมของผู้ใช้
      <br />
      ③ การวิเคราะห์ความสนใจ และพฤติกรรมของผู้ใช้ เพื่อนำไปใช้ในการแนะนำคอนเทนต์ หรือโฆษณาที่เหมาะกับแต่ละบุคคล
      <br />
      ④ การพัฒนาและปรับปรุงบริการใหม่/ การให้บริการที่ตรงกับความต้องการของผู้ใช้, การให้บริการที่หลากหลาย,
      การตอบข้อซักถาม หรือตอบข้อร้องเรียน, การแจ้งข่าวสาร
      <br />
      ⑤ กรณีที่มีการซื้อบริการ หรือรับรางวัล, การพิสูจน์ตัวตนเพื่อการส่งคอนเทนต์ หรือจัดส่งสินค้า และการชำระเงิน,
      การยืนยันอายุ, การยืนยันบัญชี
      <br />
      ⑥ การป้องกันการใช้งานที่ผิดปกติ (เช่น การสวมรอยบัญชี หรือการใช้งานโดยมิชอบ)
      <br />
      ⑦ การยืนยันการเข้าร่วมกิจกรรมหรืออีเวนต์ / การใช้ข้อมูลเพื่อการตลาดและโฆษณา
      <br />
      ⑧ การรวบรวมสถิติการใช้งาน ความถี่ในการเข้าใช้งาน เพื่อนำไปปรับปรุงบริการให้ปลอดภัย และเหมาะสมยิ่งขึ้น
      <br />
      ⑨ ในกรณีที่เกิดเหตุการณ์ที่เกี่ยวข้องกับการกระทำผิด เช่น การแฮ็กระบบ การฉ้อโกง หรือเหตุการณ์อื่นใดที่เกี่ยวข้อง
      บริษัทอาจเปิดเผยหรือให้ข้อมูลแก่หน่วยงานที่มีอำนาจตามกฎหมาย
      เพื่อวัตถุประสงค์ในการสืบสวนตามกระบวนการทางกฎหมายอย่างถูกต้องและชอบด้วยกฎหมาย
      <br />
      <p>ข้อที่ 3 การเก็บรวบรวม หรือเปิดเผยข้อมูลส่วนบุคคล</p>
      ① บริษัทจะเก็บรักษาข้อมูลส่วนบุคคลของผู้ใช้จนกว่าผู้ใช้จะร้องขอให้ลบข้อมูล
      หรือจนกว่าวัตถุประสงค์ในการเก็บรวบรวมข้อมูลนั้นจะสิ้นสุดลง และหลังจากนั้นจะดำเนินการลบ หรือทำลายข้อมูลทันที
      <br />② แม้ผู้ใช้จะยกเลิกการเป็นสมาชิกแล้ว บริษัทอาจเก็บรักษาข้อมูลบางประเภทตามระยะเวลาที่กำหนดไว้
      โดยมีรายละเอียดดังนี้
      <br />
      <br />
      <ol>
        <li>
          ข้อมูลการใช้งานบริการ (บันทึกการเข้าสู่ระบบ)
          <ol>
            <li>เหตุผลในการเก็บรักษา: เพื่อปฏิบัติตามพระราชบัญญัติว่าด้วยการกระทำความผิดเกี่ยวกับคอมพิวเตอร์</li>
            <li>ระยะเวลาในการเก็บรักษา: 3 เดือน</li>
          </ol>
        </li>
        <li>
          ข้อมูลสำหรับป้องกันการสมัครซ้ำโดยไม่สุจริต
          <ol>
            กรณีที่ผู้ใช้ยกเลิกการเป็นสมาชิก บริษัทอาจเก็บรักษาข้อมูลสมาชิกไว้เป็นระยะเวลา 1 เดือนหลังจากการยกเลิก
            เพื่อป้องกันการกระทำที่ไม่เหมาะสม เช่น การสมัครใหม่ หรือยกเลิกบัญชีซ้ำ ๆ โดยมีเจตนาไม่สุจริต เช่น
            การใช้บริการ หรือรับสิทธิประโยชน์จากกิจกรรมส่งเสริมการขายอย่างไม่เป็นธรรม
            หรือมีความเสี่ยงต่อการสวมรอยผู้อื่น
            <li>
              เหตุผลในการเก็บรักษา: ตามนโยบายภายในของบริษัท เพื่อป้องกันการใช้งานโดยมิชอบ (เช่น
              การสมัครใหม่หรือยกเลิกบัญชีโดยพลการ)
            </li>
            <li>ระยะเวลาการเก็บรักษา: 1 เดือน</li>
          </ol>
        </li>
      </ol>
      <br />
      ③ ผู้ใช้มีสิทธิที่จะปฏิเสธการให้ความยินยอมในการเก็บรวบรวม และใช้ข้อมูลส่วนบุคคล แต่ทั้งนี้
      หากปฏิเสธการให้ความยินยอม อาจไม่สามารถใช้บริการของบริษัทได้
      <br />
      ④ บริษัทจะไม่เปิดเผยข้อมูลส่วนบุคคลของผู้ใช้ต่อบุคคลภายนอก เว้นแต่ในกรณีต่อไปนี้เท่านั้น
      ได้รับความยินยอมจากผู้ใช้อย่างชัดเจนล่วงหน้า, กรณีที่กฎหมายกำหนดไว้โดยชัดเจน,
      กรณีที่จำเป็นต้องให้ข้อมูลเพื่อประโยชน์อย่างเร่งด่วนด้านชีวิต ร่างกาย
      หรือทรัพย์สินของผู้ใช้หรือบุคคลที่สามในกรณีที่มีความจำเป็นต้องให้ข้อมูลแก่บุคคลที่สามเพื่อการเชื่อมต่อบริการ
      บริษัทจะแจ้งให้ทราบล่วงหน้าอย่างชัดเจนเกี่ยวกับชื่อของหน่วยงานที่รับข้อมูล วัตถุประสงค์ของการเปิดเผย
      ข้อมูลที่เปิดเผย และระยะเวลาการเก็บรักษาและใช้งานข้อมูลของบุคคลที่สาม ภายใต้ข้อตกลงในนโยบายฉบับนี้
      <br />
      <br />
      นอกจากนี้ เพื่อให้สามารถให้บริการแก่ผู้ใช้อย่างมีประสิทธิภาพ
      บริษัทอาจมอบหมายให้บุคคลหรือนิติบุคคลภายนอกดำเนินการประมวลผลข้อมูลในบางส่วน
      โดยบริษัทจะกำกับดูแลให้ผู้รับมอบหมายปฏิบัติตามกฎหมายที่เกี่ยวข้องอย่างเคร่งครัด เมื่อมีการทำสัญญาว่าจ้าง
      บริษัทจะระบุข้อกำหนดอย่างชัดเจนในเอกสาร เช่น สัญญาว่าจ้าง ตามมาตรา 26 แห่งพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
      ได้แก่ ห้ามนำข้อมูลไปใช้เกินวัตถุประสงค์ที่กำหนดไว้, กำหนดมาตรการป้องกันทางเทคนิคและการบริหารจัดการ,
      ห้ามการมอบหมายงานต่อโดยไม่ได้รับอนุญาต, การกำกับดูแลผู้รับมอบหมาย
      และข้อกำหนดความรับผิดชอบต่อความเสียหายที่อาจเกิดขึ้น
      {/* <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>제공받는 업체명</th>
              <th>목적</th>
              <th>제공 항목</th>
              <th>개인정보 보유 및 이용기간</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>a</td>
              <td>b </td>
              <td>c</td>
              <td>d</td>
            </tr>
            <tr>
              <td>e</td>
              <td>f</td>
              <td>g</td>
              <td>h</td>
            </tr>
          </tbody>
        </table>
      </div> */}
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '50%' }}></col>
            <col style={{ width: '50%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>รายชื่อบริษัทผู้รับมอบหมายในประเทศ (เกาหลีใต้)</th>
              <th>ขอบเขตงานที่มอบหมายให้ดำเนินการ</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Kakao Corporation</td>
              <td>การบริหารจัดการโครงสร้างพื้นฐานเพื่อการให้บริการและการวิเคราะห์ข้อมูล</td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>Adena Software</td>
              <td>การพัฒนาและบำรุงรักษาระบบบริการ การดำเนินงานและบริหารจัดการระบบ การจัดเก็บข้อมูล</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '50%' }}></col>
            <col style={{ width: '50%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>รายชื่อบริษัทผู้รับมอบหมายในต่างประเทศ</th>
              <th>ขอบเขตงานที่มอบหมายให้ดำเนินการ</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Amazon Web Service, Inc</td>
              <td>การบริหารจัดการโครงสร้างพื้นฐานเพื่อการให้บริการและการวิเคราะห์</td>
            </tr>
            <tr>
              <td>Alphabet Inc.</td>
              <td>การบริหารจัดการโครงสร้างพื้นฐานเพื่อการให้บริการและการวิเคราะห์</td>
            </tr>
            <tr>
              <td>Meta Platforms Inc.</td>
              <td>การบริหารจัดการโครงสร้างพื้นฐานเพื่อการให้บริการและการวิเคราะห์</td>
            </tr>
            <tr>
              <td>Apple Inc.</td>
              <td>การบริหารจัดการโครงสร้างพื้นฐานเพื่อการให้บริการและการวิเคราะห์</td>
            </tr>
            <tr>
              <td>Anthropic PBC</td>
              <td>การบริหารจัดการโครงสร้างพื้นฐานเพื่อการให้บริการและการวิเคราะห์</td>
            </tr>
            <tr>
              <td>OpenAi Inc.</td>
              <td>การบริหารจัดการโครงสร้างพื้นฐานเพื่อการให้บริการและการวิเคราะห์</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>ข้อที่ 4 สิทธิ หน้าที่ และวิธีการใช้สิทธิของเจ้าของข้อมูลส่วนบุคคล</p>
      ผู้ใช้บริการในฐานะเจ้าของข้อมูลส่วนบุคคล มีสิทธิ์ในการใช้สิทธิดังต่อไปนี้
      <br />
      <br />
      <ol>
        ① ผู้ใช้บริการมีสิทธิ์ขอดูข้อมูลส่วนบุคคลของตน และหากพบข้อผิดพลาด สามารถขอแก้ไข ลบ
        หรือระงับการใช้ข้อมูลได้ตลอดเวลา
        <br />
        <br />
        ② ผู้ใช้บริการสามารถใช้สิทธิตามข้อ 1 โดยยื่นคำขอเป็นลายลักษณ์อักษร ทางอีเมล หรือแฟกซ์
        ตามแบบฟอร์มที่กำหนดในกฎกระทรวงคุ้มครองข้อมูลส่วนบุคคล บริษัทจะดำเนินการโดยเร่งด่วน
        <br />
        <br />
        ③ ผู้ใช้บริการสามารถให้ตัวแทนที่เป็นผู้มีอำนาจตามกฎหมาย หรือผู้ที่ได้รับมอบอำนาจ ดำเนินการแทนได้
        โดยต้องส่งหนังสือมอบอำนาจตามแบบฟอร์มที่กำหนด
        <br />
        <br />
        ④ บริษัทจะตรวจสอบว่า ผู้ที่ขอดู แก้ไข ลบ หรือระงับข้อมูล เป็นเจ้าของข้อมูลจริง หรือเป็นตัวแทนที่ได้รับอนุญาต
        <br />
        <br />
        ⑤ กรณีที่ผู้ใช้บริการหรือตัวแทน ขอแก้ไขหรือลบข้อมูลผิดพลาด
        บริษัทจะไม่ใช้หรือส่งต่อข้อมูลนั้นจนกว่าจะดำเนินการเสร็จสิ้น และจะแจ้งให้บุคคลที่ได้รับข้อมูลไปก่อนหน้านี้ทราบ
        เพื่อแก้ไขข้อมูลโดยเร็ว
        <br />
        <br />
        ⑥ บริษัทจะดำเนินการจัดการข้อมูลส่วนบุคคลที่ถูกยกเลิกหรือลบตามคำขอของผู้ใช้งานหรือตัวแทน
        ตามระยะเวลาการเก็บรักษาที่กำหนดไว้ในข้อที่ 3 “การเก็บรวบรวม หรือเปิดเผยข้อมูลส่วนบุคคล”
        และจะป้องกันไม่ให้ข้อมูลนั้นถูกเปิดเผยหรือใช้เพื่อวัตถุประสงค์อื่น
        <br />
        <br />
        ⑦ สิทธิในการขอดูข้อมูล และระงับการใช้ข้อมูลของผู้ใช้บริการอาจถูกจำกัดตามมาตรา 35 วรรค 5 และมาตรา 37 วรรค 2 ของ
        “พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล”
        <br />
        <br />
        ⑧ หากข้อมูลส่วนบุคคลนั้นถูกกฎหมายฉบับอื่นกำหนดให้เก็บรักษาไว้เป็นข้อบังคับ
        ผู้ใช้งานหรือตัวแทนจะไม่สามารถขอให้ลบข้อมูลนั้นได้
        <br />
        <br />⑨ ผู้ใช้บริการต้องไม่ละเมิดสิทธิ์ข้อมูลส่วนบุคคลหรือความเป็นส่วนตัวของตนเองหรือผู้อื่น โดยฝ่าฝืน
        “พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล” หรือกฎหมายที่เกี่ยวข้องอื่น ๆ
      </ol>
      <p>ข้อที่ 5 การลบหรือทำลายข้อมูลส่วนบุคคล</p>
      ข้อมูลส่วนบุคคลจะถูกทำลายโดยทันที ด้วยวิธีที่ไม่สามารถกู้คืนได้
      เมื่อบรรลุวัตถุประสงค์ในการเก็บรวบรวมและใช้ข้อมูลแล้ว นอกจากนี้ ตามนโยบาย “ระยะเวลาการเก็บรักษาข้อมูลส่วนบุคคล”
      ข้อมูลส่วนบุคคลของสมาชิกที่ไม่ได้ใช้บริการเป็นระยะเวลา 1 ปี จะถูกแยกเก็บรักษาไว้เป็นการเฉพาะ
      ข้อมูลส่วนบุคคลที่ถูกแยกเก็บรักษาดังกล่าว จะถูกเก็บรักษาเป็นระยะเวลา 4 ปี หลังจากนั้นจะถูกทำลายโดยทันที
      <br />
      <br />
      สำหรับข้อมูลส่วนบุคคลที่ต้องเก็บรักษาไว้ตามกฎหมาย ระยะเวลาเก็บรักษา
      และกฎหมายที่เกี่ยวข้องจะแสดงตามตารางด้านล่างนี้
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>ข้อมูลที่เก็บรักษา</th>
              <th>เหตุผลในการเก็บรักษา</th>
              <th>ระยะเวลาการเก็บรักษา</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>บันทึกเกี่ยวกับสัญญาหรือการยกเลิกคำสั่งซื้อ</td>
              <td>อ้างอิงตามพระราชบัญญัติคุ้มครองผู้บริโภคในกิจการพาณิชย์อิเล็กทรอนิกส์และธุรกรรมทางอิเล็กทรอนิกส์</td>
              <td>5 ปี</td>
            </tr>
            <tr>
              <td>บันทึกเกี่ยวกับการชำระเงินและการจัดส่งสินค้า</td>
              <td>อ้างอิงตามพระราชบัญญัติคุ้มครองผู้บริโภคในกิจการพาณิชย์อิเล็กทรอนิกส์และธุรกรรมทางอิเล็กทรอนิกส์</td>
              <td>5 ปี</td>
            </tr>
            <tr>
              <td>บันทึกเกี่ยวกับข้อร้องเรียนหรือการแก้ไขข้อพิพาทของผู้บริโภค</td>
              <td>อ้างอิงตามพระราชบัญญัติคุ้มครองผู้บริโภคในกิจการพาณิชย์อิเล็กทรอนิกส์และธุรกรรมทางอิเล็กทรอนิกส์</td>
              <td>3 ปี</td>
            </tr>
            <tr>
              <td>บันทึกเกี่ยวกับการแสดงผลหรือการโฆษณา</td>
              <td>อ้างอิงตามพระราชบัญญัติคุ้มครองผู้บริโภคในกิจการพาณิชย์อิเล็กทรอนิกส์และธุรกรรมทางอิเล็กทรอนิกส์</td>
              <td>6 เดือน</td>
            </tr>
            <tr>
              <td>บัญชีและเอกสารหลักฐานที่เกี่ยวข้องกับธุรกรรมทั้งหมดตามที่กฎหมายภาษีกำหนด</td>
              <td>กฎหมายภาษี</td>
              <td>5 ปี</td>
            </tr>
            <tr>
              <td>บันทึกการเข้าสู่ระบบที่เกี่ยวข้องกับการใช้บริการ</td>
              <td>พระราชบัญญัติคุ้มครองความลับในการสื่อสาร</td>
              <td>3 เดือน</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>ข้อที่ 6 ข้อกำหนดอื่นๆ</p>
      ① ผู้ใช้บริการสามารถตรวจสอบ หรือแก้ไขข้อมูลส่วนบุคคลของตนเองได้ตลอดเวลา
      รวมทั้งสามารถถอนความยินยอมในการเก็บรวบรวมและใช้ข้อมูล หรือขอยกเลิกการเป็นสมาชิกได้ตามต้องการ
      <br />
      <br />
      ② ข้อมูลส่วนบุคคลของเด็กที่มีอายุต่ำกว่า 14 ปี จะได้รับการคุ้มครองสิทธิ์ตามกฎหมาย ได้แก่ สิทธิในการเข้าถึง แก้ไข
      หรือลบข้อมูลส่วนบุคคล และสิทธิในการขอระงับการประมวลผลข้อมูลส่วนบุคคล เมื่อมีคำขอจากผู้แทนตามกฎหมายของเด็ก
      <br />
      <br />
      <ol>
        ③ บริษัทดำเนินการติดตั้งใช้งานคุกกี้ (cookie)
        ซึ่งเป็นไฟล์ข้อความขนาดเล็กที่ส่งจากเซิร์ฟเวอร์ของเว็บไซต์ไปยังเบราว์เซอร์ของผู้ใช้
        และเก็บไว้ในฮาร์ดดิสก์ของผู้ใช้ เพื่อใช้เก็บและเรียกคืนข้อมูลผู้ใช้ในระหว่างการใช้งานบริการอินเทอร์เน็ต
        <li>
          วัตถุประสงค์ของการใช้คุกกี้
          <ol>
            <li>
              คุกกี้เป็นไฟล์ข้อความขนาดเล็กที่ถูกส่งไปยังเบราว์เซอร์ของผู้ใช้โดยเซิร์ฟเวอร์ของเว็บไซต์
              และจัดเก็บไว้ในฮาร์ดดิสก์ของผู้ใช้ บริษัทใช้คุกกี้เพื่อให้บริการที่มีความเป็นส่วนตัว
              และตรงกับความต้องการของผู้ใช้มากขึ้น รวมทั้งใช้ข้อมูลจากประวัติการเยี่ยมชมเว็บไซต์
              รูปแบบการใช้งานของผู้ใช้ เพื่อแสดงโฆษณาที่เหมาะสม และข้อมูลที่ตรงกับความต้องการของผู้ใช้
            </li>
          </ol>
        </li>
        <li>
          การปฏิเสธคุกกี้
          <ol>
            <li>
              คุกกี้จะไม่เก็บข้อมูลที่สามารถระบุบุคคลได้ เช่น ชื่อหรือหมายเลขโทรศัพท์มือถือ
              ผู้ใช้มีสิทธิ์เลือกที่จะปฏิเสธการติดตั้งคุกกี้ได้ โดยสามารถตั้งค่าตามวิธีการในข้อที่ 6 ของวรรค 3 ข้อ 3
              อย่างไรก็ตาม หากปฏิเสธการติดตั้งคุกกี้ การใช้งานเว็บไซต์อาจไม่สะดวก
              หรืออาจมีปัญหาในการเข้าใช้บริการบางส่วนที่ต้องใช้ในการเข้าสู่ระบบ
            </li>
          </ol>
        </li>
        <li>
          วิธีการปฏิเสธคุกกี้
          <ol>
            <li>Internet Explorer: [Settings] → [Internet Options] → [Privacy] → [Advanced]</li>
            <li>Chrome: [Settings] → [Privacy and Security] → [Site Settings] → [Cookies and other site data]</li>
            <li>Edge: [Settings] → [Cookies and site permissions] → [Cookies and site data]</li>
            <li>Safari: [Preferences] → [Privacy] → [Cookies and website data]</li>
          </ol>
        </li>
      </ol>
      <ol>
        ④ บริษัทอาจเก็บรวบรวมค่า ADID/IDFA ของผู้ใช้บริการ
        <br />
        <br />
        <li>
          วัตถุประสงค์ในการเก็บรวบรวม
          <ol>
            <li>
              ADID/IDFAคือ ค่าระบุตัวผู้ใช้สำหรับการโฆษณาบนอุปกรณ์เคลื่อนที่
              ซึ่งบริษัทใช้เพื่อวัดผลและให้บริการโฆษณาที่เหมาะสม
              รวมถึงเพื่อปรับปรุงประสบการณ์ใช้งานของผู้ใช้ให้ดียิ่งขึ้น
            </li>
          </ol>
        </li>
        <li>
          วิธีปฏิเสธการเข้าถึง ADID/IDFA
          <ol>
            <li>Android: [Settings] → [Google (Google Settings)] → [Ads] → [Opt out of Ads Personalization]</li>
            <li>iOS: [Settings] → [Privacy] → [Advertising] → [Limit Ad Tracking]</li>
          </ol>
        </li>
      </ol>
      <ol>
        ⑤ บริษัทมีมาตรการในการปกป้องข้อมูลส่วนบุคคลของผู้ใช้บริการ ดังต่อไปนี้
        <li>
          บริษัทดำเนินการส่งข้อมูลส่วนบุคคลของผู้ใช้ผ่านช่องทางการสื่อสารที่มีการเข้ารหัส และจัดเก็บข้อมูลที่สำคัญ เช่น
          รหัสผ่าน โดยใช้การเข้ารหัสเพื่อเพิ่มความปลอดภัย
        </li>
        <li>
          บริษัทได้ติดตั้งระบบที่ควบคุมการเข้าถึงจากภายนอก
          เพื่อป้องกันไม่ให้ข้อมูลส่วนบุคคลของผู้ใช้บริการรั่วไหลหรือถูกทำลายจากการโจมตีของแฮกเกอร์หรือไวรัสคอมพิวเตอร์
          พร้อมติดตั้งระบบตรวจจับ ป้องกันที่สามารถตรวจสอบ และสกัดกั้นการโจมตีจากแฮกเกอร์ได้ตลอด 24 ชั่วโมง
          นอกจากนี้ยังได้ติดตั้งโปรแกรมป้องกันไวรัสเพื่อให้มั่นใจว่าระบบจะไม่ติดไวรัส หรือมัลแวร์รุ่นใหม่
          ทั้งมีการศึกษาวิจัยเทคโนโลยีด้านการแฮก และความปลอดภัยอย่างต่อเนื่องเพื่อนำมาใช้ปรับปรุงบริการ
        </li>
        <li>
          บริษัทจำกัดจำนวนพนักงานที่มีสิทธิ์เข้าถึงข้อมูลส่วนบุคคลให้เหลือน้อยที่สุด
          อีกทั้งยังมีการกำหนดหลักเกณฑ์เกี่ยวกับการสร้างและเปลี่ยนแปลงรหัสผ่านของระบบฐานข้อมูลที่ใช้เก็บรักษาข้อมูลส่วนบุคคล
          รวมถึงระบบที่ใช้ในการประมวลผลข้อมูลส่วนบุคคล พร้อมดำเนินการตรวจสอบภายในอย่างต่อเนื่อง
        </li>
        <li>
          บริษัทจัดให้มีการอบรมอย่างสม่ำเสมอแก่พนักงานทุกคนที่เกี่ยวข้องกับการจัดการข้อมูลส่วนบุคคล
          เกี่ยวกับหน้าที่ความรับผิดชอบในการคุ้มครองข้อมูลส่วนบุคคล และการรักษาความปลอดภัย
        </li>
        <li>
          บริษัทดำเนินการตรวจสอบภายในเป็นประจำเพื่อให้เป็นไปตามมาตรการป้องกันข้อมูลส่วนบุคคล
          รวมถึงเก็บรักษาและจัดการบันทึกการเข้าถึงระบบประมวลผลข้อมูลส่วนบุคคล
          และใช้ฟังก์ชันด้านความปลอดภัยเพื่อป้องกันไม่ให้บันทึกการเข้าถูกปลอมแปลง สูญหาย หรือถูกขโมย
        </li>
      </ol>
      ⑥ หากท่านมีข้อสงสัยเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคล กรุณาติดต่อที่ข้อมูลการติดต่อด้านล่าง
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>เจ้าหน้าที่รับผิดชอบ</th>
              <th>หน่วยงานที่รับผิดชอบ</th>
              <th>ติดต่อสอบถาม</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>คิมฮยอนโฮ</td>
              <td>Bubble Tap Team</td>
              <td>
                <span className="tel">{BUBBLETAP_TEL}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      หากท่านประสบปัญหาการละเมิดข้อมูลส่วนบุคคล และมีความประสงค์จะร้องเรียนหรือขอคำปรึกษา
      ท่านสามารถติดต่อหน่วยงานต่อไปนี้เพื่อขอความช่วยเหลือได้
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
            <col style={{ width: '33%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>ประเภท</th>
              <th>ช่องทางติดต่อ</th>
              <th>เว็บไซต์</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>ศูนย์รับเรื่องร้องเรียนการละเมิดข้อมูลส่วนบุคคล</td>
              <td>118 (ไม่ต้องกดรหัสประเทศ)</td>
              <td>https://privacy.kisa.or.kr</td>
            </tr>
            <tr>
              <td>แผนกสืบสวนอาชญากรรมทางไซเบอร์ สำนักงานอัยการสูงสุด</td>
              <td>1301 (ไม่ต้องกดรหัสประเทศ)</td>
              <td>https://spo.go.kr</td>
            </tr>
            <tr>
              <td>ความปลอดภัยทางไซเบอร์ สำนักงานตำรวจแห่งชาติ</td>
              <td>182 (ไม่ต้องกดรหัสประเทศ)</td>
              <td>https://ecrm.police.go.kr</td>
            </tr>
            <tr>
              <td>คณะกรรมการไกล่เกลี่ยข้อพิพาทด้านข้อมูลส่วนบุคคล</td>
              <td>1833-6972 (ไม่ต้องกดรหัสประเทศ)</td>
              <td>https://www.kopico.go.kr</td>
            </tr>
          </tbody>
        </table>
      </div>
      ⑦ การเปลี่ยนแปลงนโยบายการคุ้มครองข้อมูลส่วนบุคคล
      <br />
      <br />
      บริษัทอาจปรับปรุงหรือแก้ไขนโยบายการคุ้มครองข้อมูลส่วนบุคคล
      เพื่อให้สอดคล้องกับการเปลี่ยนแปลงของกฎหมายหรือการให้บริการต่าง ๆ โดยหากมีการเปลี่ยนแปลงใด ๆ
      บริษัทจะแจ้งให้ทราบโดยการประกาศรายละเอียดของการเปลี่ยนแปลงดังกล่าวผ่านทางเว็บไซต์ ทั้งนี้
      นโยบายที่มีการเปลี่ยนแปลงจะมีผลบังคับใช้ภายหลังจากวันประกาศอย่างเป็นทางการเป็นระยะเวลา 7 วัน
      <br />
      <br />
      อย่างไรก็ตาม ในกรณีที่มีการเปลี่ยนแปลงซึ่งอาจกระทบต่อสิทธิของผู้ใช้ เช่น
      การเปลี่ยนแปลงรายการข้อมูลส่วนบุคคลที่มีการเก็บรวบรวม หรือวัตถุประสงค์ในการใช้งานข้อมูลส่วนบุคคล
      บริษัทจะแจ้งให้ผู้ใช้ทราบล่วงหน้าไม่น้อยกว่า 30 วันก่อนวันที่มีผลบังคับใช้
      {/* 공고일자: 2022년 5월 xx일 <br />
      시행일자: 2022년 5월 xx일 */}
    </Styled.MainWrapper>
  );
}
